<template>
  <div
    ref="container"
    class="w-full h-full"
  />
</template>

<script setup>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { onMounted, onBeforeUnmount, ref } from 'vue'

const container = ref(null)
let scene, camera, renderer, controls, particleSystem

onMounted(() => {
  init()
  animate()
})

onBeforeUnmount(() => {
  if (renderer) renderer.dispose()
  window.removeEventListener('resize', onWindowResize)
})

function init() {
  // Scene & Camera
  scene = new THREE.Scene()
  camera = new THREE.PerspectiveCamera(75, container.value.clientWidth / container.value.clientHeight, 0.1, 1000)
  camera.position.z = 100

  // Renderer
  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
  renderer.setSize(container.value.clientWidth, container.value.clientHeight)
  container.value.appendChild(renderer.domElement)

  // Particle Geometry
  const geometry = new THREE.BufferGeometry()
  const particles = 2000
  const positions = new Float32Array(particles * 3)

  for (let i = 0; i < particles; i++) {
    const r = 50
    const theta = Math.random() * 2 * Math.PI
    const phi = Math.acos(2 * Math.random() - 1)
    const x = r * Math.sin(phi) * Math.cos(theta)
    const y = r * Math.sin(phi) * Math.sin(theta)
    const z = r * Math.cos(phi)

    positions.set([x, y, z], i * 3)
  }

  geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

  const material = new THREE.PointsMaterial({
    color: 0x44ccff,
    size: 1.5
  })

  particleSystem = new THREE.Points(geometry, material)
  scene.add(particleSystem)

  // Orbit Controls
  controls = new OrbitControls(camera, renderer.domElement)

  // Resize Listener
  window.addEventListener('resize', onWindowResize)
}

function animate() {
  requestAnimationFrame(animate)
  controls.update()
  renderer.render(scene, camera)
}

function onWindowResize() {
  camera.aspect = container.value.clientWidth / container.value.clientHeight
  camera.updateProjectionMatrix()
  renderer.setSize(container.value.clientWidth, container.value.clientHeight)
}
</script>

<style scoped>
div {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
canvas {
  display: block;
}
</style>
